/**
 * FE-C2g batch-3: Home / overview / group — shared contract paths.
 */

import { buildContractPath } from "./api/contract-client.js";

export const HOME_CONSOLE_TIMEOUT_MS = 16000;

export function buildPostAlertsPath() {
  return buildContractPath("post__alerts");
}

/**
 * CAP-ALERT-GROUP-1 — prefer server ``notification_group`` scope over client device_ids.
 *
 * @param {{ action: string, durationMs?: number, notificationGroup?: string, ownerAdmin?: string, deviceIds?: string[] }} opts
 */
export function buildBulkAlertBody(opts) {
  const action = String(opts.action || "").trim();
  const duration_ms = Number.isFinite(Number(opts.durationMs)) ? Number(opts.durationMs) : undefined;
  const ng = String(opts.notificationGroup || "").trim();
  const oa = String(opts.ownerAdmin || "").trim();
  if (ng) {
    const body = { action, duration_ms: duration_ms != null ? duration_ms : undefined };
    body.notification_group = ng;
    if (oa) body.owner_admin = oa;
    return body;
  }
  return {
    action,
    duration_ms: duration_ms != null ? duration_ms : undefined,
    device_ids: Array.isArray(opts.deviceIds) ? opts.deviceIds : [],
  };
}

/**
 * @param {{ group_display: string, owner_admin?: string }} opts
 */
export function buildAdminNotificationGroupSharePreviewPath(opts) {
  const query = { group_display: String(opts.group_display || "").trim() };
  const owner = opts.owner_admin != null ? String(opts.owner_admin).trim() : "";
  if (owner) query.owner_admin = owner;
  return buildContractPath("get__admin_notification-groups_share-preview", { query });
}

export function buildPostAdminNotificationGroupShareLabelPath() {
  return buildContractPath("post__admin_notification-groups_share-label");
}
